/** API case-request category: Civil Appellate Division */
export const CIVIL_APPELLATE_CATEGORY_CODE = 'CIVIL_APPELLATE';
export const FILE_CATEGORY_CIVIL_APPELLATE = 'Civil Appellate Division';

/** Set when file categories load from API; used for id-based routing once known. */
export let CIVIL_APPELLATE_CATEGORY_ID = '';

export function setCivilAppellateCategoryId(id: string) {
  CIVIL_APPELLATE_CATEGORY_ID = id.trim();
}

export function isCivilAppellateCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (code === CIVIL_APPELLATE_CATEGORY_CODE || code.includes('APPELLATE')) return true;
  if (name.includes('appellate') && name.includes('civil')) return true;
  return false;
}

export const CIVIL_APPELLATE_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Party Details' },
  { n: 3, lbl: 'Timeline' },
  { n: 4, lbl: 'Submission & Physical File Delivery' },
  { n: 5, lbl: 'Upload Documents' },
] as const;

export type CivilAppellateWizardStep = (typeof CIVIL_APPELLATE_WIZARD_STEPS)[number]['n'];

export const INCORPORATED_BODY_TYPE_LABELS = {
  unincorporated: 'Government Ministry/ Department/Other Unincorporated Body',
  incorporated: 'Public Corporation/Statutory Board/State Owned Entity/Other Incorporated Body',
} as const;
